import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Head from 'next/head'
import styles from './Faq.module.scss'
import { useRouter } from 'next/router'
import { FaqProps as Props } from './types'
import { Section } from 'types/faq'
import { faqCategoriesSlugs } from 'constants/faq-categories'
import FaqCategories from 'components/faq/faq-categories/FaqCategories'
import FaqSection from 'components/faq/faq-section/FaqSection'
import LookingForHelp from 'components/looking-for-help/LookingForHelp'
import classNames from 'classnames'
import { TITLE_POSTFIX } from 'constants/seo'

const Faq: FC<Props> = ({ sections, questions }) => {
  // Next Router
  const { locale } = useRouter()

  // i18n
  const { t } = useTranslation('faq')

  // State
  const [selectedQuestionId, setSelectedQuestionId] = useState<number | null>(null)

  // Filtered sections
  const filteredSections = sections.filter((section: Section) => faqCategoriesSlugs.common[locale].includes(section.slug))

  return (
    <>
      {/* SEO */}
      <Head>
        <title>
          {t('title')} {TITLE_POSTFIX}{' '}
        </title>
        <meta property="og:title" content={`${t('title')} ${TITLE_POSTFIX}`} key="title" />
      </Head>

      <div className={styles.faq}>
        {/* HERO */}
        <section className={styles.hero}>
          <div className="container">
            <h1 className="margin-bottom-m">{t('title', 'Veelgestelde vragen')}</h1>
            <LookingForHelp />
          </div>
        </section>

        {/* CATEGORIES */}
        <section className={styles['categories-wrapper']}>
          <div className={classNames('container', styles.container)}>
            <FaqCategories sections={filteredSections} setSelectedQuestionId={setSelectedQuestionId} />
          </div>
        </section>

        {/* QUESTIONS */}
        <section className={classNames('section', 'is-dark', styles['questions-wrapper'])}>
          <div className="container">
            <ul>
              {filteredSections.map((section: Section) => (
                <FaqSection
                  key={section.id}
                  section={section}
                  questions={questions}
                  selectedQuestionId={selectedQuestionId}
                  setSelectedQuestionId={setSelectedQuestionId}
                />
              ))}
            </ul>
          </div>
        </section>
      </div>
    </>
  )
}

export default Faq
